module.exports = __webpack_public_path__ + "media/src/images/course-page-card_inline-c2843e3b4a9a2dab1fceeb21a9122f1b.png";